import React, { useEffect, useState } from 'react'
import "react-quill/dist/quill.snow.css";
import "./quill.css";
import { useParams } from 'react-router-dom';
import Meta from '../../components/Meta/Meta';

export default function OneOfPlogPage() {
    const Api_Url = process.env.REACT_APP_API_BASE_URL;

    const [details, setDetails] = useState([]);
    const [tag, setTags] = useState([]);
    const [Seo, setSeo] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        fetch(`${Api_Url}/plog/${id}/details`)
            .then((res) => res.json())
            .then((data) => { setDetails(data) })

        fetch(`${Api_Url}/plog/${id}/tagsplog/${id}/show`)
            .then((res) => res.json())
            .then((data) => { setTags(data) })

        fetch(`${Api_Url}/plog/${id}/seoplog/${id}/show`)
            .then((res) => res.json())
            .then((data) => { setSeo(data) })
    }, [id]);






    return (
        <section className='w-full mb-10'>
            <div className="flex flex-wrap gap-2" >
                {
                    tag?.map((item, index) => (


                        <button button
                            key={index}
                            className={`${item.hidden == 0 ? 'hidden' : 'block'} bg-[#F79421] text-white px-6 py-2 rounded-md w-fit`} >
                            {item.tags}

                        </button>
                    ))
                }
            </div>

            {
                details ? (
                    <>
                        {
                            details?.map((item, index) => (
                                <div
                                    key={index}
                                    className="ql-editor text-[#333] dark:text-white content-visibility-auto"
                                    dangerouslySetInnerHTML={{ __html: item.plog }}
                                />
                            ))
                        }
                    </>
                ) : (
                    <p className="text-gray-400">جاري التحميل...</p>
                )

            }

            <div className='w-[270px]  h-[50px] mx-auto  bg-[#880807] rounded-lg  '>
                <a
                    href={`https://wa.me/${localStorage.getItem('phone')}`}
                    target='_blank'
                >
                    <button className='w-full h-full text-white px-5'>
                        أحصل علي أستشارتك المجانيه الآن
                    </button>
                </a>
            </div>

            {
                Seo?.map((item) => (
                    <Meta
                        Title={item.meta_title}
                        Description={item.meta_description}
                        keywords={item.meta_keywords}
                        key={item.id}
                    />
                ))
            }
        </section >
    )
}
